import script from "./ApikomContentView.vue?vue&type=script&setup=true&lang=js"
export * from "./ApikomContentView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__